import { ReactElement } from "react";
import styles from "./styles.module.scss";

interface ICard {
  children: ReactElement;
}

const Card = ({ children }: ICard) => {
  return (
    <div className={styles.card}>
      <div className={styles.card__container}>{children}</div>
    </div>
  );
};

export default Card;
